import { useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import {
  Dialog,
  DialogContent,
  Button,
  DialogActions,
  Typography,
} from "@mui/material";
import { LoadingButton } from '@mui/lab';
// components
import Image from '../../components/Image';
// hooks
import useAuth from '../../hooks/useAuth';
import useResponsive from '../../hooks/useResponsive';
import DIOText from "../../components/DIOText";
// utils
import axios from '../../utils/axios';
// config
import { EVENT_ID } from '../../config';

export default function InvitationLinkDialog({ open, close }) {
  const smUp = useResponsive('up', 'sm');
  const { user } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [linkCopied, setLinkCopied] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const copyLink = async () => {
    try {
      setIsLoading(true);
      const companyId = user?.employee.company[0].id;
      const response = await axios.post(`/api/company/${companyId}/invitation/`);
      const inviLink = `${window.location.origin}/invitation/?i=${response.data.code}`
      await navigator.clipboard.writeText(inviLink);
      setIsLoading(false);
      enqueueSnackbar('초대 링크가 복사되었습니다.');
      setLinkCopied(true);
    } catch(err) {
      enqueueSnackbar('초대 링크를 가져오는데 실패하였습니다. 관리자에 문의해주세요.', { variant: 'error' });
      console.error(err);
      setIsLoading(false);
    }
  }

  useEffect(() => {
    if (open) {
      setLinkCopied(false);
    }
  }, [open]);

  return (
    <Dialog open={open} onClose={close} fullWidth maxWidth="xs">
      <DialogContent sx={{ px: { xs: 3, sm: 4 }, my: { xs: 0, sm: 1 } }}>
        <Typography variant="h5" paragraph>
          <DIOText />가 필요한 스타트업에게<br/><DIOText />를 알려주세요!
        </Typography>
        <Typography variant="body2" sx={{ color: "text.secondary", mb: 4 }}>
          내 초대 링크를 통해 가입한 동료 기업이 투자 이력을 입력하면, {smUp && <br/>}동료 기업과 나 모두에게 <b>10만원 할인권</b>이 지급됩니다.
        </Typography>
        <Image
          visibleByDefault
          disabledEffect
          src="https://spacey-dio-public.s3.ap-northeast-2.amazonaws.com/images/invi-d.png"
          srcSet="
            https://spacey-dio-public.s3.ap-northeast-2.amazonaws.com/images/invi-d.png 1x,
            https://spacey-dio-public.s3.ap-northeast-2.amazonaws.com/images/invi-d%402x.png 2x,
            https://spacey-dio-public.s3.ap-northeast-2.amazonaws.com/images/invi-d%403x.png 3x,
          "
          alt="invitation gift"
          sx={{
            width: '100%', height: smUp ? '250px' : '200px',
          }}
        />
      </DialogContent>
      <DialogActions sx={{ mx: { xs: 0, sm: 1 }, mb: { xs: 0, sm: 1 } }}>
        <Button size="large" sx={{ px: 4 }} onClick={close} >
          닫기
        </Button>
        <LoadingButton
          id={EVENT_ID.bizInvitationLinkCopyInModal}
          loading={isLoading} variant="contained" size="large" sx={{ px: 4 }} onClick={copyLink}
          disabled={linkCopied}
        >
          {linkCopied ? '링크 복사 완료' : '링크 복사하기'}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}
